import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const UpdateEmailSingle = MatxLoadable({
    loader: () =>
        import ("./UpdateEmailSingle")
})
const AllUpdateEmailSingle = MatxLoadable({
    loader: () =>
        import ("./AllUpdateEmailSingle")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const UpdateEmailSingleRoutes = [
    {
        path: "/update_email_single",
        component: AllUpdateEmailSingle,
        // settings
    },

];

export default UpdateEmailSingleRoutes;